import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import Box from 'carbon-react/lib/components/box';
import { Option } from 'carbon-react/lib/components/select';
import SimpleSelect from 'carbon-react/lib/components/select/simple-select';

interface StatusFilterProps {
  onChange: (value: string) => void;
  selectedValue: string;
}

export const StatusFilter = ({ onChange, selectedValue }: StatusFilterProps) => {
  const intl = useIntl();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  const options = useMemo(
    () => [
      {
        label: intl.formatMessage({ id: 'predict.filters.status.all_statuses', defaultMessage: 'All statuses' }),
        value: 'all'
      },
      {
        label: intl.formatMessage({ id: 'common.active', defaultMessage: 'Active' }),
        value: 'active'
      },
      {
        label: intl.formatMessage({ id: 'common.invitation_sent', defaultMessage: 'Invitation sent' }),
        value: 'pending'
      }
    ],
    [intl]
  );

  return (
    <Box width={250}>
      <SimpleSelect
        label={intl.formatMessage({ id: 'common.status', defaultMessage: 'Status' })}
        onChange={handleChange}
        value={selectedValue}
      >
        {options.map(option => (
          <Option key={option.value} value={option.value} text={option.label}>
            {option.label}
          </Option>
        ))}
      </SimpleSelect>
    </Box>
  );
};
